<mat-card class="mt-3">
  <mat-card-title>{{ title | translate }}</mat-card-title>
  <mat-card-content>

    <participant-type-select #participantTypeSelect
                             [idPrefix]="idPrefix"
                             [selectedId]="selectedType"
                             [options]="typeSelectOptions"
                             [available]="true"
                             [excluded]="excludedTypes"
                             [uriBuilderParams]="participantTypeUriBuilderParams"
                             (updated)="selectedType = $event.value">
    </participant-type-select>

    <div class="row">
      <div class="col-sm-6">
        <button id="{{idPrefix}}btn.cancel" mat-stroked-button color="primary" class="w-100" (click)="closePanel()">{{ 'common.btn.cancel' | translate }}</button>
      </div>
      <div class="col-sm-6">
        <button id="{{idPrefix}}btn.save" mat-flat-button color="accent" class="w-100" (click)="createParticipant()">{{ 'common.btn.create' | translate }}</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
